/**
 * Created by Andrey Popov on 1/28/21.
 */

const DropDown = cc.Node.extend({
    ctor: function (options) {
        this._super();

        this.availableItems = options.availableItems;
        this.multiselect = options.multiselect;
        this.previewGenerator = options.previewGenerator;
        this.options = options || {};

        this.searchString = "";

        this.setContentSize(options.size);
        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.DropDown;

        if (!this.options.noExpander) {
            const expander = cleverapps.UI.createSprite(bundles.editor_controls.frames.dropdown);
            expander.setAlignment(styles.expander);
            this.addChild(expander);
        }

        cleverapps.UI.onClick(this, this.toggleDropDown.bind(this));

        this.setString(this.parseItems(options.value), true);

        cleverapps.inputDispatcher.on("keypressed", (key) => {
            if (!this.dropDownContent || !this.dropDownContent.visible) {
                return;
            }

            if (key === InputDispatcher.KEY.dash || (key >= 48 && key <= 90)) {
                this.searchString += String.fromCharCode(key).toLowerCase();
            } else if (key === InputDispatcher.KEY.backspace && this.searchString.length > 0) {
                this.searchString = this.searchString.substring(0, this.searchString.length - 1);
            }

            this.showValue();

            this.buildDropDownContent();
            this.toggleDropDown();
        }, this);
    },

    toggleDropDown: function () {
        if (!this.dropDownContent) {
            this.buildDropDownContent();
        }

        if (this.dropDownContent.visible) {
            this.dropDownContent.setVisible(false);
            this.searchString = "";
            cleverapps.UI.findNodes(cc.EditBox).forEach((editBox) => {
                editBox.visible = true;
            });
        } else {
            const styles = cleverapps.styles.DropDown;
            const pos = cleverapps.Scenes.GetRunningScene().convertToNodeSpace(this.dropDownContent.convertToWorldSpace());
            if (pos.y < styles.dropUp.yThreshold && !this.options.downOnly) {
                this.dropDownContent.setAlignment(this.dropDownContent.x, this.height);
            } else {
                this.dropDownContent.setAlignment(this.dropDownContent.x, -this.dropDownContent.height);
            }

            this.dropDownContent.setVisible(true);
            cleverapps.UI.findNodes(cc.EditBox).forEach((editBox) => {
                editBox.visible = false;
            });
        }
        this.options.onToggleShow && this.options.onToggleShow(this.dropDownContent.visible);
    },

    showValue: function () {
        if (this.shownValue) {
            this.shownValue.removeFromParent();
            delete this.shownValue;
        }

        if (this.searchString && this.searchString.length > 0) {
            this.shownValue = cleverapps.UI.generateOnlyText(this.searchString, cleverapps.styles.FONTS.SEARCH_DROP_DOWN_TEXT);
        } else if (this.value) {
            let stringValue = this.multiselect ? this.value.join(", ") : this.value;
            if (stringValue.length > 22) {
                stringValue = `${stringValue.replaceAll("landscape_", "").replaceAll("portrait_", "")
                    .replaceAll("square_", "").substring(0, 22)}...`;
            }
            this.shownValue = cleverapps.UI.generateOnlyText(stringValue, this.options.font || cleverapps.styles.FONTS.DROP_DOWN_TEXT);
            if (!this.multiselect && this.availableItems.indexOf(this.value) === -1) {
                this.shownValue.setFontFillColor(cleverapps.styles.COLORS.DARK_RED);
            }
        }

        if (this.shownValue) {
            this.shownValue.setDimensions(this.width, this.height);
            this.shownValue.setVerticalAlignment(this.options.verticalAlignment !== undefined ? this.options.verticalAlignment : cc.VERTICAL_TEXT_ALIGNMENT_TOP);
            this.shownValue.setHorizontalAlignment(this.options.horizontalAlignment !== undefined ? this.options.horizontalAlignment : cc.TEXT_ALIGNMENT_LEFT);
            this.shownValue.setAnchorPoint(0.5, 0.5);
            this.shownValue.setAlignment(this.width / 2, this.height / 2);

            this.addChild(this.shownValue);
        }
    },

    setDelegate: function (delegate) {
        this.delegate = delegate;
    },

    getString: function () {
        return this.value;
    },

    setString: function (value, initial) {
        if (this.multiselect && !initial) {
            if (value === "SELECT ALL") {
                this.value = this.parseItems(this.availableItems);
            } else if (value === "UNSELECT ALL") {
                this.value = [];
            } else {
                const index = this.value.indexOf(value);
                if (index === -1) {
                    this.value.push(value);
                } else {
                    this.value.splice(index, 1);
                }
            }
        } else {
            this.value = value;
        }

        this.searchString = "";

        this.showValue();

        if (!initial) {
            this.toggleDropDown();
        }

        if (this.dropDownContent) {
            this.dropDownContent.removeFromParent();
            delete this.dropDownContent;
        }
    },

    buildDropDownContent: function () {
        const styles = cleverapps.styles.DropDown;

        if (this.dropDownContent) {
            this.dropDownContent.removeFromParent();
        }
        if (this.clickPastDropDown) {
            this.clickPastDropDown.remove();
            this.clickPastDropDown = undefined;
        }

        const dropDownWidth = this.width + (this.previewGenerator ? styles.preview.width : 0);
        const availableItems = this.parseItems(this.availableItems);
        if (this.multiselect) {
            availableItems.push("SELECT ALL");
            availableItems.push("UNSELECT ALL");
        }

        const itemNodes = availableItems.filter((item) => {
            if (!this.searchString || this.searchString.length === 0) {
                return true;
            }
            return item.toLowerCase().indexOf(this.searchString) !== -1;
        }).map((item) => {
            const preview = this.previewGenerator && this.previewGenerator(item);
            const isSelected = this.multiselect ? this.value.indexOf(item) !== -1 : item === this.value;
            const itemFont = this.options.font || (isSelected ? cleverapps.styles.FONTS.SELECTED_DROP_DOWN_TEXT : cleverapps.styles.FONTS.DROP_DOWN_TEXT);

            const itemText = cleverapps.UI.generateOnlyText(item, itemFont);

            itemText.setDimensions(dropDownWidth, 0);
            itemText.setHorizontalAlignment(this.options.horizontalAlignment !== undefined ? this.options.horizontalAlignment : cc.TEXT_ALIGNMENT_LEFT);
            let itemNode = itemText;
            if (preview) {
                cleverapps.UI.fitToBox(preview, styles.preview);
                itemText.setDimensions(dropDownWidth - styles.preview.width - styles.preview.margin, 0);
                itemText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
                itemNode = new cleverapps.Layout([preview, itemText], {
                    direction: cleverapps.UI.HORIZONTAL,
                    margin: styles.preview.margin
                });
            }
            cleverapps.UI.onClick(itemNode, () => {
                this.setString(item);
                if (this.delegate) {
                    this.delegate.editBoxEditingDidEnd(this);
                }
                if (!this.multiselect) {
                    cleverapps.UI.findNodes(cc.EditBox).forEach((editBox) => {
                        editBox.visible = true;
                    });
                }
            });

            return itemNode;
        });
        const items = new cleverapps.Layout(itemNodes, {
            direction: cleverapps.UI.VERTICAL
        });

        let scrollHeight = styles.scroll.height;
        if (items.height < scrollHeight) {
            scrollHeight = items.height;
        }

        const background = cleverapps.UI.createScale9Sprite(bundles.editor_controls.frames.component, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(dropDownWidth + 2 * styles.scroll.bgPadding, scrollHeight + 2 * styles.scroll.bgPadding);

        const scroll = new cleverapps.UI.ScrollView(items, {
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL
        });
        scroll.setContentSize2(dropDownWidth, scrollHeight);
        scroll.setAlignment(background.width / 2, background.height / 2);
        background.addChild(scroll);

        const dropDownContent = this.dropDownContent = cleverapps.UI.createScale9Sprite(bundles.editor_controls.frames.component);
        dropDownContent.setContentSize2(dropDownWidth, background.height);

        background.setAlignment(dropDownContent.width / 2, dropDownContent.height / 2);
        dropDownContent.addChild(background);
        dropDownContent.setVisible(false);
        dropDownContent.setAnchorPoint(0, 0);
        dropDownContent.setAlignment(this.width - dropDownWidth, -dropDownContent.height);
        dropDownContent.setLocalZOrder(100);

        this.addChild(dropDownContent);

        this.clickPastDropDown = cleverapps.pointerManager.create(this, {
            onOuterTouch: function () {
                if (dropDownContent.visible) {
                    this.toggleDropDown();
                }
            }.bind(this)
        });
    },

    parseItems: function (items) {
        return typeof items === "function" ? items() : cleverapps.clone(items);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DROP_DOWN_TEXT: {
        size: 20,
        color: cleverapps.styles.COLORS.COLOR_VERY_DARK_GRAY,
        name: "formal"
    },

    SELECTED_DROP_DOWN_TEXT: {
        size: 20,
        color: cleverapps.styles.COLORS.BLACK,
        name: "formal"
    },

    SEARCH_DROP_DOWN_TEXT: {
        size: 20,
        color: cleverapps.styles.COLORS.COLOR_BLUE,
        name: "formal"
    }
});

cleverapps.styles.DropDown = {
    expander: {
        x: { align: "right", dx: -8 },
        y: { align: "center" }
    },

    scroll: {
        height: 500,
        bgPadding: 2
    },

    preview: {
        width: 90,
        height: 90,
        margin: 5
    },

    dropUp: {
        yThreshold: 110,
        dy: 30
    }
};